<template>
  <div class="page">
    <nav-bar/>
    <search-bar/>

    <div class style="width: 100%;">
      <div class="page-content">


        <div class="p10 bg_white">
          我的文章>文章详情
        </div>


        <!--        左边文章详情  右边 最新发布-->
        <div class="article fr mt15 ">
          <div class="left ">

            <div class="fc jc ac mt40">
              <div class="fz18">{{information.information_title}}</div>

              <div class="mt30 fz12 grey">
                <span>文章来源：平台</span>
                <span class="ml40">发表日期：{{information.create_time}}</span>
              </div>
            </div>


            <!--            分割线-->

            <el-divider></el-divider>

            <!--            文章内容-->

            <div class="article-content" v-html="information.information_desc"></div>

<!--            文章图片-->


            <div class="fc jc ac">

              <img class="mt20" style="width: 200px;height: 200px" :src="item" v-for="(item,index) in information.information_imgs.split(',')" :key="index" alt="">


            </div>
            <!--            分割线-->

            <el-divider></el-divider>

          </div>
          <div class="right ml20">

            <div class="p10" style="border-bottom: 1px solid #f5f5f5">最新发布</div>

            <div class="new-list">
              <div class="item fr ac p10" style="border-bottom: 1px solid #f5f5f5">

                <div class="">
                  <div>浅谈轻型输送带的优点和缺点</div>

                  <div class="fz14 grey" style="margin-top: 5px">
                    造成输送带撕裂的主要原因有
                  </div>

                  <div class="fz14 grey mt30">
                    2019-09-11
                  </div>
                </div>
                <div class=" ml20">
                  <img src="/static/imgs/home/banner.png" style="width: 100px;height: 100px" alt="">
                </div>
              </div>

            </div>

          </div>

        </div>

      </div>
    </div>

    <footer-bar/>
  </div>
</template>

<script>
  import NavBar from "@/components/NavBar";
  import SearchBar from "@/components/SearchBar";
  import FooterBar from "@/components/FooterBar";

  export default {
    props: {},
    data() {
      return {
        information: {
          information_id: "",
          information_desc: "<h1>我是文章内容</h1>",
          information_imgs:""
        }

      };
    },
    computed: {},
    created() {
    },
    mounted() {

      let param = this.$route.query;
      this.information.information_id = param.information_id;
      this.getInformationDetail();

    },
    methods: {
      getInformationDetail() {
        let param = {
          information_id: this.information.information_id
        };
        this.post("informationInterfaces/v1.0/getInformationDetail", param).then(res => {
          this.information = res.data;
        })

      }
    },
    components: {
      "nav-bar": NavBar,
      "search-bar": SearchBar,
      "footer-bar": FooterBar
    }
  };
</script>

<style scoped lang="scss">
  .page-content {
    width: 1200px;
    margin: 20px auto;
  }

  .article {
    .left {
      width: 800px;
      background-color: white;
      padding: 20px;
    }

    .right {
      width: 380px;
      background-color: white;
      padding: 10px;
    }

    .article-content {
      padding: 20px 100px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/page/me/myInformation/detail.vue